import { createLazyComponent } from '@muse-web/router'

export const AsyncMobileDrawer = createLazyComponent(
    () => import(/* webpackChunkName: 'mobile-drawer' */ './MobileDrawer'),
    'MobileDrawer',
)
